<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['exam_sets'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-examsetting size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Exam Setting</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(exam)="data">
                  {{ data.item.exam.name }}
                </template>
                <template #cell(schoolclass)="data">
                  <b class="text-danger">{{ data.item.schoolclass.name }}</b>
                  <br />
                </template>
                <template #cell(term)="data">
                  {{ data.item.schoolterm.name }} - {{ data.item.year }}
                </template>
                <template #cell(status)="data">
                  <span v-if="data.item.status == '1'">Yes</span>
                  <span v-else>No</span>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(
                          data.item.id,
                          data.item.schoolclass.id,
                          data.item.schoolterm.id,
                          data.item.year,
                          data.item.exam.id,
                          data.item.status,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="
                        remove(
                          data.item.id,
                          data.item.schoolclass.name,
                          data.item.exam.name,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-examsetting"
        centered
        title="New Exam Setting"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addExamSetting">
          <div class="form-group mb-2">
            <label>Class</label>
            <v-select
              :options="schoolclasses"
              placeholder="Select Class"
              label="name"
              v-model="schoolclass"
              :reduce="(schoolclasses) => schoolclasses.id"
            ></v-select>
            <label>Term</label>
            <multiselect
              v-model="schoolterm"
              label="name"
              :options="schoolterms"
            ></multiselect>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Exam</label>
            <v-select
              :options="examsets"
              placeholder="Select Exam"
              label="name"
              v-model="exam"
              :reduce="(examsets) => examsets.id"
            ></v-select>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-examsetting')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-examsetting"
        centered
        title="Edit Exam Setting"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editExamSetting">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Class</label>
            <v-select
              :options="schoolclasses"
              placeholder="Select Class"
              label="name"
              v-model="schoolclass"
              :reduce="(schoolclasses) => schoolclasses.id"
            ></v-select>
            <label>Term</label>
            <v-select
              :options="schoolterms"
              placeholder="Select Term"
              v-model="schoolterm"
              label="name"
              :reduce="(schoolterms) => schoolterms.id"
            ></v-select>
            <label>Year</label>
            <b-form-input v-model="year" type="number"></b-form-input>
            <label>Exam</label>
            <v-select
              :options="examsets"
              placeholder="Select Exam"
              label="name"
              v-model="exam"
              :reduce="(examsets) => examsets.id"
            ></v-select>
            <label>Appear on report</label>
            <b-form-input v-model="status"></b-form-input>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-examsetting')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-examsetting"
        centered
        title="Delete Exam Setting"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeExamSetting">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Exam Setting :
          <b>{{ schoolclass }} - {{ exam }} </b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-examsetting')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  examsetComputed,
  examsetMethods,
  examsettingComputed,
  examsettingMethods,
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Exam Settings",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Exam Settings",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Exam Settings", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "schoolclass", label: "Class", visible: true },
        { key: "term", label: "Term", visible: true },
        { key: "exam", label: "Exam", visible: true },
        { key: "status", label: "Appear on report", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      schoolclass: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      exam: "",
      status: "",
    };
  },
  computed: {
    ...examsetComputed,
    ...schooltermComputed,
    ...schoolclassComputed,
    ...examsettingComputed,
    List() {
      return this.examsettings.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.examsettings.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.examsettings.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.fetchExamSettings();
    this.fetchExamSets();
    this.TotalRows = this.examsettings.length;
    this.isBusy = false;
    // this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...examsetMethods,
    ...schooltermMethods,
    ...schoolclassMethods,
    ...examsettingMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, schoolclass, schoolterm, year, exam) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.schoolterm = schoolterm;
      this.year = year;
      this.exam = exam;
      this.$bvModal.show("edit-examsetting");
    },
    remove(id, schoolclass, exam, status) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.exam = exam;
      this.status = status;
      this.$bvModal.show("delete-examsetting");
    },
    async addExamSetting() {
      let formData = new FormData();
      formData.append("schoolclass", this.schoolclass);
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("exam", this.exam);
      let url = "/addexamsetting";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchExamSettings();
          this.$bvModal.hide("new-examsetting");
          this.schoolclass = "";
          this.exam = "";
          this.year = "";
          this.schoolterm = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editExamSetting() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("schoolclass", this.schoolclass);
      formData.append("schoolterm", this.schoolterm);
      formData.append("year", this.year);
      formData.append("exam", this.exam);
      formData.append("status", this.status);
      let url = "/updateexamsetting";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchExamSettings();
          this.$bvModal.hide("edit-examsetting");
          this.schoolclass = "";
          this.exam = "";
          this.year = "";
          this.schoolterm = "";
          this.status = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeExamSetting() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeexamsetting";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchExamSettings();
          this.$bvModal.hide("delete-examsetting");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
